import React from 'react'
import SimpleBanner from '../../components/User/Common/SimpleBanner'
import BlogPage from '../../components/User/Blog/Blogpage'

const Blog = () => {
  return (
    <div>
        <SimpleBanner title='Blog' subheading='Home > Blog'/>
        <BlogPage/>
    </div>
  )
}

export default Blog